import Image from 'next/image'
import { useRouter } from 'next/router'

import { cx } from '@linaria/core'

import { sendCampaignClick } from '~/libs/gtm'

import { Container } from '../layout/Container'

export const CampaignBannerLink: React.FC<{
  campaignName: string
  campaignLink: string
  imageUrl: string
  imageWidth: number
  imageHeight: number
  disableMargin?: boolean
}> = (props) => {
  const router = useRouter()
  return (
    <Container>
      <div
        className={cx(
          'flex justify-center',
          props.disableMargin ? '' : 'mx-4 mt-3 md:mx-0'
        )}
      >
        <button
          type="button"
          onClick={async () => {
            sendCampaignClick(props.campaignName)
            await router.push(props.campaignLink)
          }}
        >
          <Image
            src={props.imageUrl}
            alt=""
            width={props.imageWidth}
            height={props.imageHeight}
            unoptimized
          />
        </button>
      </div>
    </Container>
  )
}
